import { Col, Form, Row, Select } from "antd";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import { extractDate } from "../../config/helpers";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Get } from "../../config/api/get";
import { ADMIN, UPLOADS_URL } from "../../config/constants/api";
import { TiArrowSortedDown } from "react-icons/ti";
import { Post } from "../../config/api";
import swal from "sweetalert";

const ReportDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = useSelector((state) => state.user.userToken);
  const [chauffeurs, setChauffeurs] = useState([]);
  const bookingDetails = location?.state?.data;
  
  useEffect(() => {
    if (!bookingDetails) {
      navigate(-1);
    } else if (!bookingDetails?.chauffeur) {
      // Only fetch chauffeurs if no chauffeur is assigned
      getChauffeursByService();
    }
    // eslint-disable-next-line
  }, []);

  const getChauffeursByService = async () => {
    Get(ADMIN.getChauffeursByService, token, {
      serviceType: bookingDetails?.serviceType,
    })
      .then((response) => {
        if (response?.status) {
          setChauffeurs(response.data?.docs || []);
        }
      })
      .catch((err) => {
        console.log("Error fetching chauffeurs ", err);
      });
  };

  const onFinish = (values) => {
    Post(
      `${ADMIN.assignChauffeur}${bookingDetails?._id}`,
      {
        chauffeurId: values.selectedChauffeur,
      },
      token
    )
      .then((response) => {
        if (response?.status) {
          swal("Success", response?.message, "success");
          navigate("/reservationRequests");
        }
      })
      .catch((err) => {
        console.log("Error assigning chauffeur ", err);
        const message = err?.response?.data?.message || err?.message;
        if (message) {
          swal("Error", message, "error");
        }
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const formatinHours = (minutes) => {
    return minutes / 60;
  };

  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div
          className="bg-white rounded-lg sm:py-16 py-8 my-12"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <div className="flex justify-start items-center mx-1 lg:mx-8 mb-4">
            <IoIosArrowRoundBack
              onClick={() => navigate(-1)}
              className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
            />
            <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
              Reservation Details
            </h3>
          </div>

          <Row justify="center">
            <Col xs={23}>
              <Row justify="" gutter={[32, 16]} className="mb-6">
                <Col lg={12} xs={22}>
                  <div className="flex flex-col items-center justify-center h-full w-full">
                    <div class="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center desktop:p-6 p-3 mb-8 w-full h-full">
                      <h5 class="w-full text-start mb-4 font-tavi text-xl text-black font-semibold max-desktop:text-lg">
                        Client Details
                      </h5>
                      <img
                        src={bookingDetails?.user?.image 
                          ? UPLOADS_URL + bookingDetails.user.image 
                          : "/assets/images/avatar.png"}
                        onError={(e) => {
                          e.target.src = "/assets/images/avatar.png";
                        }}
                        style={{
                          marginBottom: "40px",
                          height: "150px",
                          width: "150px",
                          objectFit: "cover",
                          objectPosition: "center",
                          borderRadius: "100%",
                        }}
                        alt="profile"
                      />
                      <div
                        class="mt-3"
                        style={{
                          display: "flex",
                          gap: "0 50px",
                          flexWrap: "wrap",
                        }}
                      >
                        <div class=" items-start">
                          <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                            Full Name
                          </h5>
                          <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                            {bookingDetails?.user?.firstName}{" "}
                            {bookingDetails?.user?.lastName}
                          </p>
                        </div>
                        <div class=" items-start">
                          <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                            Requested Service Type
                          </h5>
                          <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                            {bookingDetails?.serviceType} Luxury
                          </p>
                        </div>
                        <div class=" items-start">
                          <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                            From
                          </h5>
                          <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                            {bookingDetails?.pickupLocation?.address}
                          </p>
                        </div>

                        <div class=" items-start">
                          <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                            Booking Date
                          </h5>
                          <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                            {extractDate(bookingDetails?.date)}
                          </p>
                        </div>
                        <div class=" items-start">
                          <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                            Booking Duration
                          </h5>
                          <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                            
                            {formatinHours(bookingDetails?.duration) >= 1
                              ? `${formatinHours(bookingDetails?.duration)} Hours`
                              : bookingDetails?.duration + " Minutes"}
                          </p>
                        </div>
                        <div class=" items-start">
                          <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                            Amount Paid
                          </h5>
                          <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                            ${bookingDetails?.initialCharges.toFixed(2)}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center desktop:p-8 p-3 w-full h-full">
                      <h5 className="w-full text-start mb-4 font-tavi text-xl text-black font-semibold max-lg:text-lg">
                        Additional Notes
                      </h5>
                      <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                        {bookingDetails?.notes ? bookingDetails?.notes : "-"}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={12} xs={22}>
                  <div className="flex flex-col items-center w-full">
                    {bookingDetails?.chauffeur ? (
                      <div class="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center desktop:p-6 p-3 mb-8 w-full h-full">
                        <h5 class="w-full text-start mb-4 font-tavi text-xl text-black font-semibold max-desktop:text-lg">
                          Assigned Chauffeur
                        </h5>
                        <div className="flex flex-col items-center justify-center w-full">
                          <img
                            src={bookingDetails?.chauffeur?.image 
                              ? UPLOADS_URL + bookingDetails.chauffeur.image 
                              : "/assets/images/avatar.png"}
                            onError={(e) => {
                              e.target.src = "/assets/images/avatar.png";
                            }}
                            style={{
                              marginBottom: "20px",
                              height: "150px",
                              width: "150px",
                              objectFit: "cover",
                              objectPosition: "center",
                              borderRadius: "100%",
                            }}
                            alt="chauffeur profile"
                          />
                          <div
                            class="mt-3"
                            style={{
                              display: "flex",
                              gap: "0 50px",
                              flexWrap: "wrap",
                              width: "100%",
                            }}
                          >
                            <div class=" items-start">
                              <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                                Full Name
                              </h5>
                              <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                                {bookingDetails?.chauffeur?.firstName}{" "}
                                {bookingDetails?.chauffeur?.lastName}
                              </p>
                            </div>
                            {bookingDetails?.chauffeur?.phone && (
                              <div class=" items-start">
                                <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                                  Phone
                                </h5>
                                <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                                  {bookingDetails?.chauffeur?.phone}
                                </p>
                              </div>
                            )}
                            {bookingDetails?.chauffeur?.email && (
                              <div class=" items-start">
                                <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                                  Email
                                </h5>
                                <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                                  {bookingDetails?.chauffeur?.email}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div class="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center desktop:p-6 p-3 mb-8 w-full h-full">
                        <h5 class="w-full text-start mb-4 font-tavi text-xl text-black font-semibold max-desktop:text-lg">
                          Assign Chauffeur
                        </h5>
                        <Form
                          name="assignChauffeur"
                          layout="vertical"
                          onFinish={onFinish}
                          onFinishFailed={onFinishFailed}
                        >
                          <Form.Item
                            name="selectedChauffeur"
                            label={
                              <p className="font-euclid text-sm text-[#34324B]">
                                Select Chauffeur to Assign
                              </p>
                            }
                            rules={[
                              {
                                required: true,
                                message: "Please select a chauffeur!",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select Chauffeur"
                              className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                              suffixIcon={<TiArrowSortedDown />}
                              options={chauffeurs.map((item) => ({
                                label: (
                                  <span className="font-euclid text-sm text-black">
                                    {item?.chauffeur?.firstName}{" "}
                                    {item?.chauffeur?.lastName}
                                  </span>
                                ),
                                value: item?.chauffeur?._id,
                              }))}
                            />
                          </Form.Item>

                          <button
                            className="uppercase bg-button py-3 px-4 xl:px-16 text-black rounded-lg font-bold text-sm max-desktop:text-[10px] max-md:py-2 max-md:px-4 mr-3 font-euclid"
                            htmlType="submit"
                          >
                            Assign
                          </button>
                        </Form>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default ReportDetails;
